import { Box } from '@mui/material';
import { CloseIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { Formik } from 'formik';
import { PoolButton, PoolDrawer, PoolDrawerHeader } from '@synergy/components-next';
import { ReactElement } from 'react';
import { ScrollToFieldError } from '@synergy/components';
import { Stack, styled } from '@mui/material';

import { SingleInquiryContent } from './single-inquiry-content';
import { singleInquiryDataSelector } from '../../../store/single-inquiry-selectors';
import { singleInquiryValidationSchema } from './single-inquiry-validation-schema';
import { useAppSelector } from '../../../../store/store';
import { useSingleInquiryContext } from './single-inquiry';

const StickyContainer = styled(Box)(({ theme }) => ({
    position: 'sticky',
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
    bottom: 0,
    zIndex: 2,
}));

export const SingleInquiryDrawer = (): ReactElement | null => {
    const { isOpen, initialValues } = useAppSelector(singleInquiryDataSelector);
    const { onClose, onSubmit } = useSingleInquiryContext();

    return (
        <PoolDrawer open={isOpen}>
            <PoolDrawerHeader onClick={onClose}>
                <CloseIcon />
                <FormattedMessage id="app.modal.title.singleInquiry.mobile" />
            </PoolDrawerHeader>
            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={singleInquiryValidationSchema}
                enableReinitialize={true}
            >
                {formikProps => (
                    <>
                        <ScrollToFieldError />
                        <Stack justifyContent="space-between">
                            <Box sx={{ px: 2, pt: 3 }}>
                                <SingleInquiryContent />
                            </Box>
                            <StickyContainer>
                                <PoolButton fullWidth={true} onClick={() => formikProps.handleSubmit()}>
                                    <FormattedMessage id="app.modal.button.send.mobile" />
                                </PoolButton>
                            </StickyContainer>
                        </Stack>{' '}
                    </>
                )}
            </Formik>
        </PoolDrawer>
    );
};
